export function formatPlannedLessons(value: number | null | undefined): string {
  return value === null || value === undefined
    ? "计划课时数 未填写"
    : `计划课时数 ${value}节`;
}

export function TeacherPlannedLessonsText({
  value,
  className = ""
}: {
  value: number | null | undefined;
  className?: string;
}): React.JSX.Element {
  return (
    <span className={`teacher-planned-lessons ${className}`.trim()}>
      {formatPlannedLessons(value)}
    </span>
  );
}
